var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import styles from './TooltipTrigger.module.css';
const DISPLAY_CLASS_MAP = {
    flex: styles.Flex,
    inline: styles.Inline,
    'inline-flex': styles.InlineFlex,
};
export const TooltipTrigger = ({ children, display = 'inline', triggerProps, }) => (_jsx("span", { ...triggerProps, className: DISPLAY_CLASS_MAP[display], children: children }));
_react_refresh_temp_1 = TooltipTrigger;
$RefreshReg$(_react_refresh_temp_1, "TooltipTrigger");
